/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_KnowledgebaseInputs */

const en_nav_knowledgebase = /** @type {(inputs: Nav_KnowledgebaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledgebase`)
};

const es_nav_knowledgebase = /** @type {(inputs: Nav_KnowledgebaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de conocimiento`)
};

/**
* | output |
* | --- |
* | "Knowledgebase" |
*
* @param {Nav_KnowledgebaseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_knowledgebase = /** @type {((inputs?: Nav_KnowledgebaseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_KnowledgebaseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_knowledgebase(inputs)
	return es_nav_knowledgebase(inputs)
});